module.exports = __webpack_public_path__ + "static/logo-ethereum-54319703d4c4f61aa485eed380736118.png";